import { render } from "./Index.vue?vue&type=template&id=381878f1&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=381878f1&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-381878f1"

export default script